module.exports = __webpack_public_path__ + "static/media/office_2.f630a94f.jpg";